import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixShare3Icon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M12 3.11719V14.9543"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.6428 6.75937L12.0006 3.11719L8.3584 6.75937"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M4.71582 12.2188V19.5031C4.71582 19.9861 4.90768 20.4493 5.24921 20.7908C5.59073 21.1324 6.05393 21.3242 6.53691 21.3242H17.4635C17.9465 21.3242 18.4097 21.1324 18.7512 20.7908C19.0927 20.4493 19.2846 19.9861 19.2846 19.5031V12.2188"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
